import * as fromDatatype from '../datatype-library/index';

export interface bl_cms_form_template_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    notify_contact: fromDatatype.VarcharDatatypeInterface;
    email_body_template: fromDatatype.TextDatatypeInterface;
    email_title_template: fromDatatype.VarcharDatatypeInterface;
    form_name: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_cms_form_template_hdr_RowClass implements bl_cms_form_template_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    notify_contact: fromDatatype.VarcharDatatypeInterface;
    email_body_template: fromDatatype.TextDatatypeInterface;
    email_title_template: fromDatatype.VarcharDatatypeInterface;
    form_name: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}